var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
import Skeleton from '../../Progress/Skeleton/Skeleton';
const ChipContainer = styled.div `
  font-size: ${props => props.theme.utils.getSize(props.fontSize)};
  border: ${props => props.isFull ? 'none' : props.theme.utils.customBorders(props.color)};
  position: relative;
  font-family: ${props => props.theme.fonts.fontFamily};
  margin: ${props => props.noMargin ? '0' : props.theme.paddingsMargins.themeMenuMargin};
  color: ${props => props.theme.utils.getColor(props.textColor)};
  display: inline-flex;
  justify-content: center;
  align-items: stretch;
  border-radius: ${props => props.theme.borders.borderRadius};
  background-color: ${(props) => props.isFull ? props.color ? props.theme.utils.getColorLight(props.color) : props.secondary ? props.theme.colors.secondaryLight : props.theme.colors.mainLight : 'white'};
`;
const ChipStyle = styled.div `
  padding: ${props => props.noPadding ? '0.3rem' : props.theme.paddingsMargins.themeMenuPadding};
`;
const DeleteStyle = styled.div `
  display: flex;
  align-items: center;
  padding: ${props => props.noPadding ? '0.3rem' : props.theme.paddingsMargins.themeMenuPadding};
  color: 'white';
  background-color: ${(props) => !props.isFull ? props.theme.utils.getColor(props.color) : 'none'};
  border-top-right-radius: ${props => props.theme.borders.borderRadius};
  border-bottom-right-radius: ${props => props.theme.borders.borderRadius};
  &:hover {
    color: white;
    cursor: pointer;
    border-top-right-radius: ${props => props.theme.borders.borderRadius};
    border-bottom-right-radius: ${props => props.theme.borders.borderRadius};
    background-color: ${(props) => props.color ? props.theme.utils.getColorDark(props.color) : props.secondary ? props.theme.colors.secondaryDark : props.theme.colors.mainDark};}
`;
const Chip = (_a) => {
    var { fontSize = 'subArticle', noPadding = false, noMargin = false, secondary = false, isFull = true, canDelete, index = 0, onDeleteChip, children, color = '', textColor = 'white', excludeMeFromLoadingContext = false, skeleton } = _a, props = __rest(_a, ["fontSize", "noPadding", "noMargin", "secondary", "isFull", "canDelete", "index", "onDeleteChip", "children", "color", "textColor", "excludeMeFromLoadingContext", "skeleton"]);
    const { loadingContext } = useCronoSkeleton();
    const showDelete = canDelete;
    return (children
        ? (loadingContext && excludeMeFromLoadingContext === false)
            ? _jsx(Skeleton, Object.assign({ height: '25px', width: "80px", margin: "v", display: 'inline-flex' }, skeleton))
            : _jsxs(ChipContainer, Object.assign({ fontSize: fontSize, color: color, secondary: secondary, noMargin: noMargin, isFull: isFull, textColor: textColor }, props, { children: [_jsx(ChipStyle, Object.assign({ noPadding: noPadding }, { children: children })), showDelete && (_jsx(DeleteStyle, Object.assign({ color: color, isFull: isFull, noPadding: noPadding, onClick: (e) => { e.stopPropagation(); onDeleteChip && onDeleteChip(index); }, secondary: secondary }, { children: "x" })))] }))
        : _jsx(_Fragment, {}));
};
export default Chip;
